import React from "react";
import { Menu, X } from "lucide-react";

import Logo from "./components/Logo";
import HeaderBuildVersion from "./components/HeaderBuildVersion";
import Navigation from "./components/Navigation";
import UserActions from "./components/UserActions";

import { useAuth } from "../../context/AuthContext";
import { canShowMaisSidebar } from "../../lib/screenAccess";
import { useHeader } from "./context/HeaderContext";

const Header: React.FC = () => {
  const { user } = useAuth();
  const { isMobileMenuOpen, toggleMobileMenu } = useHeader();
  const roleName = user?.role?.nome?.toLowerCase() || "";
  const isRoterista = roleName === "roterista";
  const isForneiro = roleName === "forneiro";
  const isBordeiro = roleName === "bordeiro";
  const shouldHideNavigation = isRoterista || isForneiro || isBordeiro;
  const canToggleSidebar = canShowMaisSidebar(user) && !shouldHideNavigation;

  const toggleSidebar = () => {
    if (typeof window === "undefined") return;
    const key = "db_sidebar_mais_expanded";
    const eventName = "db-sidebar-mais-toggle";
    const expanded = window.localStorage.getItem(key) !== "0";
    window.localStorage.setItem(key, expanded ? "0" : "1");
    window.dispatchEvent(new Event(eventName));
  };

  return (
    <nav className="sticky top-0 z-40 overflow-visible border-b border-primary/40 bg-primary">
      {canToggleSidebar && (
        <button
          type="button"
          onClick={toggleSidebar}
          className="absolute left-3 top-1/2 z-50 hidden h-8 w-8 shrink-0 -translate-y-1/2 items-center justify-center rounded-md border border-white/35 bg-white/10 p-0 text-white transition-colors hover:bg-white/20 lg:inline-flex"
          aria-label="Expandir ou recolher menu lateral"
          title="Expandir ou recolher menu lateral"
        >
          <Menu size={16} />
        </button>
      )}
      <div
        className={`mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8 ${
          canToggleSidebar ? "lg:pl-14" : ""
        }`}
      >
        <div className="flex min-h-14 items-center py-1 lg:min-h-14 lg:py-1">
          <div className="flex min-w-0 flex-1 items-center gap-2">
            {!shouldHideNavigation && (
              <button
                type="button"
                className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-white/95 transition-colors hover:bg-white/10 lg:hidden"
                onClick={toggleMobileMenu}
                aria-label={isMobileMenuOpen ? "Fechar menu" : "Abrir menu"}
              >
                {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
              </button>
            )}
            <div className="shrink-0">
              <Logo />
            </div>
          </div>
          {!shouldHideNavigation && (
            <div className="flex min-w-0 justify-center">
              <Navigation />
            </div>
          )}
          <div className="flex min-w-0 flex-1 items-center justify-end gap-2 sm:gap-3">
            <HeaderBuildVersion />
            <UserActions />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
